export { default as WrapStrong } from './WrapStrong';
